import { Controller } from "react-hook-form";
import {
    Select,
    SelectItem,
    DatePicker,
    Textarea,
    NumberInput,
} from "@heroui/react";
import { ThemedText } from "@/components/ui";

const TransactionInfoStep = ({ control, errors, selectOptions, setValue }) => {
    const { transactionCategories, isLoadingTransactionCategories } =
        selectOptions;
    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <Controller
                name="transaction_date"
                control={control}
                rules={{
                    required: "Tanggal wajib diisi",
                }}
                render={({ field }) => (
                    <DatePicker
                        isRequired
                        label="Tanggal & Waktu"
                        variant="bordered"
                        hideTimeZone
                        showMonthAndYearPickers
                        granularity="minute"
                        value={field.value}
                        onChange={field.onChange}
                        errorMessage={errors.transaction_date?.message}
                        isInvalid={!!errors.transaction_date}
                    />
                )}
            />
            <Controller
                name="transaction_category_id"
                control={control}
                rules={{
                    required: "Kategori wajib dipilih",
                }}
                render={({ field }) => (
                    <Select
                        isRequired
                        label="Kategori Transaksi"
                        placeholder="Pilih Kategori"
                        variant="bordered"
                        selectedKeys={field.value ? [field.value] : []}
                        onChange={field.onChange}
                        errorMessage={errors.transaction_category_id?.message}
                        isInvalid={!!errors.transaction_category_id}
                        isLoading={isLoadingTransactionCategories}
                    >
                        {(transactionCategories || []).map((item) => (
                            <SelectItem key={item.value} value={item.value}>
                                {item.title}
                            </SelectItem>
                        ))}
                    </Select>
                )}
            />
            <div className="md:col-span-2">
                <Controller
                    name="amount"
                    control={control}
                    rules={{
                        required: "Nominal wajib diisi",
                    }}
                    render={({ field }) => (
                        <NumberInput
                            isRequired
                            label="Nominal"
                            placeholder="0"
                            value={field.value || undefined}
                            onValueChange={(val) => {
                                field.onChange(val);
                                setValue("amount", val);
                            }}
                            variant="bordered"
                            minValue={0}
                            hideStepper
                            startContent={
                                <ThemedText size="sm" variant="secondary">
                                    Rp
                                </ThemedText>
                            }
                            formatOptions={{
                                style: "decimal",
                                minimumFractionDigits: 0,
                            }}
                            errorMessage={errors.amount?.message}
                            isInvalid={!!errors.amount}
                        />
                    )}
                />
            </div>
            <div className="md:col-span-2">
                <Controller
                    name="description"
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            label="Keterangan"
                            placeholder="Contoh: Pembayaran Invoice #123"
                            variant="bordered"
                            value={field.value}
                            onValueChange={field.onChange}
                            errorMessage={errors.description?.message}
                            isInvalid={!!errors.description}
                        />
                    )}
                />
            </div>
        </div>
    );
};

export default TransactionInfoStep;
